import React, { useState, useEffect } from "react";
import Loading from "../../../../common/Loading";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useEyeconxStore } from "../../../../../store/eyeconxStore";
import clinicService from "../../../../../services/clinic.service";
import { useForm } from "react-hook-form";
import SocialCard from "./SocialCard";

const Addlinkform = ({showAdd,updateLinks,getLinks}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const { clinicId } = useParams();
  const onSubmit = (data) => {
    clinicService.updateSocialLinks(clinicId,data)
    .then(res=>{
        
        toast.success("Added Social Link",{
            position:toast.POSITION.BOTTOM_RIGHT
        })
        //updateLinks(res.data)
        //console.log(res.data)
        getLinks()
        showAdd()
        
    })
    .catch(err=>{
        
        toast.error("Unable to Add Social Link",{
            position:toast.POSITION.BOTTOM_RIGHT
        })
    })
  };
  return (
    <>
      <div className="card">
        <div className="card-body p-3">
          <form onSubmit={handleSubmit(onSubmit)}>
            <select className="form-control mb-2" {...register("type")}>
              <option value="WEBSITE">WEBSITE</option>
              <option value="GOOGLE_PAGE">GOOGLE_PAGE</option>
              <option value="FACEBOOK">FACEBOOK</option>
              <option vlaue="INSTAGRAM">INSTAGRAM</option>
              <option value="TWITTER">TWITTER</option>
              <option value="YELP">YELP</option>
              <option value="OTHER">OTHER</option>
            </select>

            <input type="hidden" {...register("clinicId")} value={clinicId} />
            <input
              className="form-control mb-2"
              placeholder="url"
              {...register("link")}
            />

            <button type="submit" className="btn btn-primary">
              Add
            </button>
          </form>
        </div>
      </div>
    </>
  );
};
function SocialTab() {

  const [loading, setLoading] = useState(false);
  const { clinicId } = useParams();
  const [socialLinks, setSocialLinks] = useState([]);
  const [addNew, setAddNew] = useState(false);
 

  useEffect(() => {
   getLinks()
  }, [clinicId]);

  const handleAddClick = () => {
    setAddNew(!addNew);
  };

  const getLinks = ()=>{
   // console.log("Getting social Liks : "+clinicId)
    setLoading(true);
    clinicService
    .getSocialLinks(clinicId)
    .then((res) => {
      setSocialLinks(res.data);
      setLoading(false);
    })
    .catch((err) => {
     // console.log("Error Getting SOcial LInk");
      //console.log(err);
      setLoading(false);
    });
  }

  const updateLinks = (link)=>{
        const index = socialLinks.findIndex(obj => obj.id === link.id)
        const newArray = [...socialLinks]
        newArray[index] = {...newArray[index],link:link.link};
        setSocialLinks(newArray)
  }
  const deleteLink =(linkid)=>{
      //to do
  }
  return (
    <>
      <div className="d-flex justify-content-between">
        <h5 className="card-title" style={{ color: "#012970" }}>
          {" "}
          Social Links
        </h5>
        <div>
          <button
            className="btn btn-secondary btn-sm mt-2"
            onClick={handleAddClick}
          >
            <i className="bi bi-person-plus bi-sm"></i> Add New
          </button>
        </div>
      </div>
     
          {loading ? (
             <Loading />
          ) : <div className="row">
              {Array.isArray(socialLinks) && socialLinks.length >0 ?(
                socialLinks.map((linkitem,index)=>( <SocialCard key={index} updatelinks={updateLinks} linkitem={linkitem} getLinks={getLinks}/>))
             ):"No Social LInks"}
               </div>
          }
      
      <div className="row">
        <div className="col-4">{addNew ? <Addlinkform showAdd={handleAddClick} updateLinks={updateLinks} getLinks={getLinks} /> : ""}</div>
      </div>
    </>
  );
}

export default SocialTab;
